<template>
  <div class="faq">
    <div
      v-for="(f, i) in items"
      :key="i"
      class="qa reveal"
      :class="{ open: openIndex === i }"
      v-reveal="{ delay: i * 70 }"
    >
      <button
        class="qa-q"
        type="button"
        :aria-expanded="openIndex === i ? 'true' : 'false'"
        @click="toggle(i)"
      >
        <span>{{ f.q }}</span>
        <span class="qa-ico" aria-hidden="true">
          <IconSvg :name="openIndex === i ? 'close' : 'plus'"/>
        </span>
      </button>
      <div v-show="openIndex === i" class="qa-a"><p>{{ f.a }}</p></div>
    </div>
  </div>
</template>

<script>
import IconSvg from './IconSvg'

export default {
  name: 'FaqList',
  components: { IconSvg },
  props: {
    items: { type: Array, default: () => [] }
  },
  data() {
    return { openIndex: 0 }
  },
  methods: {
    toggle(i) {
      this.openIndex = this.openIndex === i ? -1 : i
    }
  }
}
</script>

<style lang="scss" scoped>
.faq {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 940px;
  margin: 0 auto;
}

.qa {
  border-radius: 14px;
  border: 1px solid var(--line);
  background: linear-gradient(120deg, rgba(11, 23, 48, 0.62), rgba(5, 12, 27, 0.5));
  transition: border-color 0.4s, background 0.4s;

  &.open { border-color: color-mix(in srgb, var(--accent) 45%, transparent); }
}

.qa-q {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 18px 22px;
  border: 0;
  background: none;
  text-align: left;
  cursor: pointer;
  font-size: 15.5px;
  font-weight: 600;
  color: #fff;

  &:hover { color: var(--accent-txt); }
  &:focus-visible { outline: 2px solid var(--accent); outline-offset: -2px; border-radius: 14px; }
}

.qa-ico {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: var(--accent-txt);
}

.qa-a {
  padding: 0 22px 20px;

  p {
    font-size: 14px;
    line-height: 1.95;
    color: var(--txt-3);
    padding-top: 4px;
    border-top: 1px solid rgba(120, 176, 255, 0.1);
    padding-left: 0;
    padding-right: 0;
    margin-top: 0;
  }
}
</style>
